<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>维护货件</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="93px"
          >
        <el-form-item
            label="店铺/国家">
          <span>{{transferOrders[0].arrivalMarketName}}</span>
        </el-form-item>
        <el-form-item
            label="ShipmentID"
            prop="shipmentId"
            :rules="[
              { required: true, message: '请输入ShipmentID', trigger: ['blur', 'change'] }
            ]">
          <gj-textarea
              v-model="form.shipmentId"
              placeholder="如果有多个，仅支持每行填写一个"
              :styles="{height: '200px', fontSize: '12px'}"
          ></gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>

  import {formRuleMixin, modalMixIn, responseMixin} from "../../../../../../minxins";
  import {splitAndUnique} from "../../../../../../utils/common";
  import {maintainTransferShipment} from "../../../../../../api/warehouse";

  export default {
    name: "app-maintain-fba-shipment-modal",
    mixins: [modalMixIn, formRuleMixin, responseMixin],
    props: {
      transferOrders: {
        required: true
      }
    },
    data() {
      return {
        confirmLoading: false,
        form: {
          shipmentId: null
        }
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.confirmLoading = true;
          const shipmentIds = splitAndUnique(this.form.shipmentId);
          maintainTransferShipment({
            ids: this.transferOrders.map(item => item.id),
            shipmentIdList: shipmentIds,
          })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('操作成功');
                this.$emit('maintained');
                this.$gjDestroy();
              })
            })
            .complete(() => this.confirmLoading = false);
          
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding: 8px 20px 0 20px;
  }
</style>

